// One bundle for every customer sandbox: pliny serves on the same origin as the
// UI, so each box's own address is its API.
export const API_DOMAIN = window.location.origin;
export const API_URL = `${API_DOMAIN}/api`;
export const VANTAGE_API_URL = `${API_DOMAIN}/vantage/api`;
export const SOCKET_IO_URL = window.location.origin;
export const GA_TRACKING_CODE = null;
export const BLUETOOTH_PSK = '123356789ABCDEF01122334455667788';
export const BRAND_PRIMARY = '#b3261e';
export const BRAND_SECONDARY = '#9e9e9e';
